export const SET_USDC_BALANCE = "SET_USDC_BALANCE";
export const SET_SAN_BALANCE = "SET_SAN_BALANCE";
